import { graphql } from '../gql';

export const getFinancialInfoForVendorAtLocation = graphql(`
  query GetFinancialInfoForVendorAtLocation($input: GetFinancialInfoForVendorAtLocation!) {
    getFinancialInfoForVendorAtLocation(input: $input) {
      error {
        code
        message
      }
      sales {
        foodTopSales(limit: 4) {
          name
          percentGfs
        }
      }
    }
  }
`);
